import { TFilterDropDownData } from "../../../../fixtures/data-fixtures/ComponentConfigFixtures";

const Checkbox = (props: ICheckbox) => {
	return (
		<>
			<div className="dd-list-block zf-padding-t-xs zf-padding-b-xs">
				<input
					className="zf-margin-none check-box"
					type="checkbox"
					checked={props.isChecked}
					onChange={() => props.onFilterChange(props.item)}
				></input>
				<label className="zf-text-font-size-s zf-text-color-black-80 zf-margin-l-xxl-8">
					{props.item.value}
				</label>
			</div>
		</>
	);
};

export default Checkbox;

interface ICheckbox {
	item: TFilterDropDownData;
	isChecked: boolean;
	onFilterChange: (item: TFilterDropDownData) => void;
}
